import { render, staticRenderFns } from "./NumberRuleCreater.vue?vue&type=template&id=4fe8ea88&scoped=true"
import script from "./NumberRuleCreater.vue?vue&type=script&lang=js"
export * from "./NumberRuleCreater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8ea88",
  null
  
)

export default component.exports